import Layout from "../../../components/layout";
import MainContent from "../../../components/maincontent";
import React from "react";
import Schedule from "../../../components/schedule/2024/schedule";
import Seo from "../../../components/seo";
import BackButtonInSchedules from "../../../components/navigation/backbuttoninschedules";

const currentYear = "2024";
const dateRange = "October 9th - October 13th";

const IndexPage = () => (
  <Layout>
    <Seo
      title={`Camp ${currentYear} - Schedule`}
      description={`Schedule for Charity Grace Bible Camp ${currentYear}`}
      lang="en"
      meta={[
        {
          content: "God, Jesus, Gospel, Heaven, Salvation, Saved, Grace, Free, How, Mid-Acts, Romans, Charity Grace Bible Church, Illinois",
          name: "keywords"
        }
      ]}
    />

    <MainContent
      hasArticle={false}
      hasBanner={false}
    >

      <BackButtonInSchedules   />
      
      <div className="grid--4 grid-padding align--center">
        <h2>Camp Schedule {currentYear}</h2>
        {/*<h3>{campTitle}</h3>*/}
        <span className="caption">{dateRange}</span>
      </div>

      {/*<div className="grid--4 grid-padding align--center">*/}
      {/*  <a*/}
      {/*    href={`/assets/pdf/CGBC_${currentYear}_Schedule.pdf`}*/}
      {/*    className="button button--green"*/}
      {/*    download=""*/}
      {/*    target="_blank"*/}
      {/*    rel="noopener"*/}
      {/*  >*/}
      {/*    <i className="fa fa-file-pdf-o" aria-hidden="true" /> Download PDF*/}
      {/*  </a>*/}
      {/*</div>*/}
    </MainContent>
    <Schedule />
  </Layout>
);

export default IndexPage;
